export enum FieldOption {
    Text = 1,
    DropdownState,
    PhoneMask,
    CheckPassword,
    ShowReadOnly,
    DropDownOfficeContact,
    DropDownOfficeProfessional,
    ZipCodeMask,
    NumLimitMask,
    DateWidget
}
